module.exports = __webpack_public_path__ + "img/totalicon01.bd4e8abb.png";